export const YYYY_MM_DD_HH_MM_SS_SSSZ = 'YYYY-MM-DDTHH:mm:ss.sssZ'
export const MONTHS_IN_YEAR = 12
export const MM_DD_YYYY = 'MM/DD/YYYY'
export const YYYY_MM_DD = 'YYYY-MM-DD'
export const MM_YYYY = 'MM/YYYY'
export const YYYY_MM = 'YYYY-MM'
export const MMMM_YYYY = 'MMMM YYYY'
